/**
 * batch-63 integrator - het domein van een e-mailadres en de lijst publieke
 * mailproviders. Eén bron voor de certificaat-mailbox (FO-469, opleider via het
 * afzenderdomein) en de cursusaanvraag (FO-468, is de afzender de opleider?):
 * beide streams bouwden dezelfde functie en een eigen providerlijst, en de barrel
 * exporteerde `emailDomein` daardoor dubbel (TS2308).
 */

/** Domein (kleine letters) van een e-mailadres, of null als het geen adres is. */
export function emailDomein(adres: string | null | undefined): string | null {
  const t = (adres ?? '').trim().toLowerCase()
  const at = t.lastIndexOf('@')
  if (at < 1 || at === t.length - 1) return null
  return t.slice(at + 1)
}

/**
 * Publieke mailproviders: een gelijk domein zegt daar niets over de afzender
 * (alleen een exact adres telt). Vereniging van de lijsten uit beide streams.
 */
export const PUBLIEKE_MAILDOMEINEN: ReadonlySet<string> = new Set([
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.nl',
  'outlook.com',
  'outlook.nl',
  'live.com',
  'live.nl',
  'msn.com',
  'yahoo.com',
  'yahoo.nl',
  'icloud.com',
  'me.com',
  'ziggo.nl',
  'kpnmail.nl',
  'kpnplanet.nl',
  'planet.nl',
  'home.nl',
  'xs4all.nl',
  'hetnet.nl',
  'casema.nl',
  'chello.nl',
  'telfort.nl',
  'tele2.nl',
  'online.nl',
  'upcmail.nl',
  'onsbrabantnet.nl',
  'gmx.com',
  'gmx.net',
  'proton.me',
  'protonmail.com',
])
